import Vue from 'vue';
import MessageBox from './MessageBox';
export {default} from './MessageBox';

/* Usage: */
/* 

installation run: setup(Vue)

e.g. vueCompontent: {
  methods: {
    async whatever() {
      const confirmed = await this.$alert(options)

      Options can be either a String, containing the message or it can be an options object: 

      {
        type: 'alert',
        title: '',
        message: '',
        closeOnConfirm: true,
        closeOnReject: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Close',
      }
    }
  }
}
*/

const MessageBoxConstructor = Vue.extend(MessageBox);
let instance = null;

const initInstance = (doc) => {
  instance = new MessageBoxConstructor({
    el: doc.createElement('div'),
  });
};

export const setup = (Vue, doc = window.document) => {
  if (!instance) {
    initInstance(doc);
  }

  Vue.prototype.$alert = (options = {}) => {
    /* If Options is single string overwrite as message */
    if (typeof options === 'string') {
      options = {
        message: options,
      };
    }

    const defaults = {type: 'warning'};
    const settings = Object.assign({}, defaults, options);

    /* Set settings, given they exist on the insance */
    Object.keys(settings).forEach((key) => {
      if (instance.hasOwnProperty(key)) {
        instance[key] = settings[key];
      }
    });

    instance.open = true;

    return new Promise((resolve, reject) => {
      instance.resolveFunction = resolve;
      instance.rejectFunction = reject;
    });
  };

  doc.body.appendChild(instance.$el);

  return instance;
};
